/* card and envelope sizes */
// Card dimensions match gpt-image-1's 1536x1024 (3:2) aspect ratio for perfect image fit
// If fallback to DALL-E 3 (1792x1024), image will be slightly scaled to fit
export const CARD_W = 600;
export const CARD_H = 400;  // 600/400 = 3:2 ratio, matches gpt-image-1's 1536x1024
export const ENV_W  = CARD_W + 40;
export const ENV_H  = CARD_H / 2 + 70;
export const FLAP_H = 120;
export const PREVIEW_H = ENV_H + FLAP_H + CARD_H + 40;

export const CARD_HIDE_Y = ENV_H - 1;
export const CARD_PEAK_Y = -40;

export const MARGIN  = 20;
export const HEAD_Y  = 40;
